import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentDownload = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentDownload' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,9 L12,18 M8,15 L12,19 L16,15' />
  </StyledIcon>
);
